<template>
   <span v-if="isOwner && hasValue && isPrivate">
     <span v-b-tooltip.hover
           title="This data is set by you as Private and is not accessible to other Affiliates"
     >
          <font-awesome-icon :icon="['fas', 'lock']" size="sm"/>
     </span>
   </span>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    affiliate: Object,
    field: String,
  },
  computed: {
    ...mapGetters({
      authed: 'auth/isAuthenticated',
      user: 'auth/user',
    }),
    hasValue() {
      return !!this.affiliate[`${this.field}`] ?? null;
    },
    isOwner() {
        return this.authed && this.user.id === this.affiliate.id;
    },
    isPrivate() {
      return this.affiliate[`${this.field}Visibility`] === 'private' ?? null;
    },
  },
};
</script>
